// extracted by mini-css-extract-plugin
export default {"controlButton":"styles_controlButton__iiF2l","bordered":"styles_bordered__Qxy5V","replay":"styles_replay__Wmiod","disabled":"styles_disabled__h2mxS"};